var map = {
	"./DrLubhani/ChangeColor": [
		747,
		169
	],
	"./Ganga/ChangeColor": [
		749,
		175
	],
	"./Indus/ChangeColor": [
		751,
		188
	],
	"./Kabini/ChangeColor": [
		753,
		195
	],
	"./Kaveri/ChangeColor": [
		665,
		18
	],
	"./Luni/ChangeColor": [
		755,
		201
	],
	"./Narmada/ChangeColor": [
		757,
		204
	],
	"./Neyyar/ChangeColor": [
		759,
		211
	],
	"./Periyar/ChangeColor": [
		761,
		214
	],
	"./SAANVI/ChangeColor": [
		763,
		224
	],
	"./Sabarmathi/ChangeColor": [
		765,
		231
	],
	"./Sutlej/ChangeColor": [
		767,
		237
	],
	"./Yamuna/ChangeColor": [
		769,
		243
	],
	"./pamba/ChangeColor": [
		771,
		252
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2009;
module.exports = webpackAsyncContext;